import React, { Component } from "react";
import PDF from "../CommonPDF/PDF";
import "./TotalMaster.css";

import { Input, notification } from "antd";
import dateFormat from "dateformat";
import Paper from "@material-ui/core/Paper";
import Pdf from "../../Images/pdf.svg";
import Print from "../../Images/print.svg";
import Excel from "../../Images/excel.svg";
import Tablecomponent from "../DeliveryTracking/table/TableComp";
//import Tablecomponent from "../../helpers/TableComponent/TableComp";
import DateRangeSelect from "../../helpers/DateRange/DateRange";
import "./TotalTable.css";
import axiosInstance from "../../api/axiosInstance";
import { apiurl, timerDifference, formatMoney } from "../../App";
//Print excel pdf
import ReactToPrint from "react-to-print";
// import ReactExport from "react-data-export";
import PrintData from "./PrintData";
import { ReactSVG } from "react-svg";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AddIcon from "@material-ui/icons/Add";
import Filter from "../../Images/filter.svg";
import AdvanceFilter from "../AdvanceFillter/AdvanceFilter";
import PrescriptionDetailView from "../PrescriptionDetailView/PrescriptionDetailView";
import { withTranslation } from "react-i18next";
import more from "../../Images/more.svg";
import downloadExcel from "../CommonExcel/Excel";
import { NavLink } from "react-router-dom";
import BackButton from "../../assets/images/Group 31.svg";
import AddmedicineModal from "./Addmedicine";
import Editmedicine from "./Editmedicine"
import tickblackicon from "../../assets/images/tickblack.svg";
import tickfillicon from "../../assets/images/tickfill.svg";
import editpencilicon from "../../assets/images/editpencil.svg";
import ShowNotification from "../ShowNotification/ShowNotification";


import plusicon from "../../assets/images/add_plus.png";
import { HiOutlinePlusCircle } from "react-icons/hi";
import Cookies from "js-cookie";

import { decryptAESKey, setupKeys, encryptData, decryptData } from '../Crypto_Helpers/cryptoHelper';
import { initEncryptionSession } from '../../encryptionSession';

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const headRows = [
  { id: "sno", label: "S.No", typeDt: "sno" },
  { id: "orderId", label: "ID" },
  { id: "customer", label: "Member", typeDt: "str" },
  { id: "phone_no", label: "Member Phone no" },
  { id: "doctorName", label: "Doctor", typeDt: "str" },
  { id: "approval_received_on", label: "Approval received on", typeDt: "date" },
  { id: "deliverd_on", label: "Delivered on", typeDt: "date" },
  { id: "timer", label: "Time taken" },
  { id: "billed_amount", label: "Rate ", typeDt: "amt", type: "amt" },
];
class TotalMaster extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      medicineData: [],
      prescriptionEntryData: null,
      pharmacyId: null,
      search: "",
      prescriptionopenview: false,
      prescriptionView: false,
      open: false,
      props_loading: false,
      spinner: false,
      open_filter: false,
      selected_doctor_id: 0,
      startDate: "",
      toDate: "",
      startdate: "",
      enddate: "",
      isModalOpen: false,
      iseditModalOpen: false,
      medicineID: null,
      page: 1,
      rowsPerPage: 25,
      visible: false,
      successmsg: "",
      wk_Mn_Yr_Full_Data: [],
    };
    // Bind the method
    this.editmedicine = this.editmedicine.bind(this);
  }
  componentDidMount() {
    this.dayReport(
      [
        {
          startDate: "",
          endDate: "",
          key: "selection",
        },
      ],
      true
    );

    this.intervalId = setInterval(() => {
      this.dayReport(
        [
          {
            startDate: "",
            endDate: "",
            key: "selection",
          },
        ],
        true
      );
    }, 120000);
  }

  componentWillUnmount() {
    // Clear the interval when the component is unmounted to avoid memory leaks
    clearInterval(this.intervalId);
  }

  dateRangeSelect = (date) => {
    this.setState(
      {
        startdate: dateFormat(date[0].startDate, "yyyy-mm-dd"),
        toDate: dateFormat(date[0].endDate, "yyyy-mm-dd"),
      },
      () => this.getTableData()
    );
  };

  dayReport = (data) => {
    this.getTableData();

    // debugger;
    // function formatTimeShow(h_24) {
    //   var h = Number(h_24.substring(0, 2)) % 12;
    //   if (h === 0) h = 12;
    //   return (
    //     (h < 10 ? "0" : "") +
    //     h +
    //     ":" +
    //     h_24.substring(3, 5) +
    //     (Number(h_24.substring(0, 2)) < 12 ? " AM" : " PM")
    //   );
    // }
    // this.setState({
    //   props_loading: true,
    //   // startdate: dateFormat(data[0].startDate, "yyyy-mm-dd"),
    //   // toDate: dateFormat(data[0].endDate, "yyyy-mm-dd"),
    // });
    // var startdate = data[0].startDate;
    // var enddate = data[0].endDate;
    // // var startdate = dateFormat(data[0].startDate, "yyyy-mm-dd");
    // // var enddate = dateFormat(data[0].endDate, "yyyy-mm-dd");
    // this.setState({ spinner: true });
    // var self = this;
  };
  searchChange = (e) => {
    this.setState({ search: e.target.value });
  };
  modelopen = (data, id) => {
    if (data === "view") {
      let prescriptionEntryData = this.state.wk_Mn_Yr_Full_Data.filter(
        (val) => val.prescription_id === id
      );
      if (
        prescriptionEntryData.length > 0 &&
        !prescriptionEntryData.medicines
      ) {
        prescriptionEntryData[0].medicines = [];
      }
      this.setState(
        {
          prescriptionEntryData,
          prescriptionopenview: true,
        },
        () => { }
      );
    } else if (data === "prescription") {
      this.setState({ prescriptionView: true, prescription_id: id });
    }
  };
  closemodal = () => {
    this.setState({ prescriptionopenview: false, prescriptionView: false });
  };
  iconclick = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ prescriptionopenview: false, prescriptionView: false });
  };
  handleopenSuccess = (successmsg, issuccess) => {
    this.setState({ visible: true, successmsg, issuccess });

    if (this.closeNotificationTimeout) {
      clearTimeout(this.closeNotificationTimeout);
    }
    this.closeNotificationTimeout = setTimeout(() => {
      this.handleCloseSuccess();
    }, 3000);
  };

  handleCloseSuccess = () => {
    this.setState({ visible: false });
    if (this.closeNotificationTimeout) {
      clearTimeout(this.closeNotificationTimeout);
      this.closeNotificationTimeout = null;
    }    
  };

  // data has empty this alert msg showed print pdf excel
  Notification = () => {
    notification.warning({
      message: "No data found",
      placement: "topRight",
    });
  };
  //Pdf Generation
  generatepdf = () => {
    if (this.state.tableData.length === 0) {
      notification.warning({
        message: "No data found",
        placement: "topRight",
      });
    } else {
      const doc = new jsPDF("a4");

      var imagesssdata =
        "data:image/png;base64,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";
      doc.addImage(imagesssdata, "JPEG", 15, 15, 20, 25);
      var bodydata = [];
      this.state.tableData.map((data, index) => {
        bodydata.push([
          index + 1,
          data.orderId,
          data.customer,
          data.phone_no,
          data.doctorName,
          data.approval_received_on,
          data.deliverd_on,
          data.timer,
          data.billed_amount,
        ]);
      });
      const bodyStyles = {
        lineWidth: 0.3,
        halign: "center", // Align content to the center horizontally
      };

      doc.autoTable({
        beforePageContent: function (data) {
          doc.setTextColor(81, 15, 48);
          doc.text("Delivered Orders", 14, 43); // 15,13 for css
        },
        margin: { top: 50 },
        showHead: "everyPage",
        theme: "grid",
        head: [
          [
            {
              content: "S.No",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: "ID",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: "Member",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: "Member Phone no",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: "Doctor",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: "Approval received on",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: "Delivered on",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: "Time taken",
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
            {
              content: `Rate (${"₹"})`,
              styles: {
                fillColor: [81, 15, 48],
                textColor: 255,
                fontStyle: "bold",
                halign: "start",
              },
            },
          ],
        ],
        body: bodydata,
        bodyStyles: {
          cellStyles: bodydata.map((row) =>
            row.map((cell) => (cell ? cell.styles || bodyStyles : ""))
          ),
          lineWidth: 0.3,
        },
      });
      doc.save("TotalOrders.pdf");
    }
  };
  handleOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  // Method to close the modal
  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
    this.getTableData();
  };

  openAdvanceFilter = () => {
    this.setState({ open_filter: true });
  };
  closeAdvanceFilter = () => {
    this.setState({ open_filter: false });
  };

  editmedicine = (id) => {
    this.setState({medicineID:id,  iseditModalOpen: true});
  };
  
  editCloseModal = () => {
    this.setState({ iseditModalOpen: false });
    this.getTableData();
  };
  getTableData = async () => {
     const aesKey = await initEncryptionSession();
    const isEditModalOpen = this.state.iseditModalOpen;
    this.setState({ props_loading: true });
    const pharmId = Cookies.get("pharmacy_id") || localStorage.getItem("pharmacy_id") || localStorage.pharmacy_id || 0;
    var data = {
      pharmacy_id: (pharmId && pharmId !== "undefined" && pharmId !== "null") ? Number(pharmId) : 0,
      pageNumber: 0,
      pageSize: 0,
    };
     const encrypted = await encryptData(data, aesKey);
    axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/get_mas_pharm_medicine_rate",
      data: {
        objects: encrypted
      },
    })
      .then(async (response) => {
        var tableData = [];
        var tableDatafull = [];
        let dataList = [];
        if (response.data && response.data.status === 1 && response.data.data) {
          if (typeof response.data.data === "string") {
            dataList = await decryptData(response.data.data, aesKey);
          } else if (Array.isArray(response.data.data)) {
            dataList = response.data.data;
          }
        }
        this.setState({ medicineData: dataList });
        if (Array.isArray(dataList)) {
          dataList.forEach((val) => {
            const statusBadge = (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <span className={`px-2.5 py-1 rounded-full text-xs font-bold flex items-center gap-1.5 ${
                  val.sales_admin_sts === "A"
                    ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                    : "bg-amber-50 text-amber-700 border border-amber-200"
                }`}>
                  <span className={`w-1.5 h-1.5 rounded-full ${val.sales_admin_sts === "A" ? "bg-emerald-500" : "bg-amber-500"}`} />
                  {val.sales_admin_sts === "A" ? "Active" : "Pending"}
                </span>
              </div>
            );

            const editButton = (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <button
                  type="button"
                  onClick={() => this.editmedicine(val.id)}
                  className="w-8 h-8 rounded-xl bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white flex items-center justify-center transition-all cursor-pointer shadow-2xs"
                  title="Edit Medicine"
                >
                  <img src={editpencilicon} style={{ width: "16px", height: "16px" }} alt="Edit" />
                </button>
              </div>
            );

            tableData.push({
              Medicine_ID: val.id,
              Medicine_Name: val.medicine_name + (val.dosage ? ` (${val.dosage})` : ""),
              Unit: val.stock !== null && val.stock !== undefined ? val.stock : "-",
              Price: val.per_stock_price ? `${"₹"} ${parseFloat(val.per_stock_price).toFixed(2)}` : "-",
              Qty: val.per_tablet_price ? `${"₹"} ${parseFloat(val.per_tablet_price).toFixed(2)}` : "-",
              MFG_Date: val.mfg_date ? dateFormat(val.mfg_date, "dd-mmm-yy") : "-",
              EXP_Date: val.exp_date ? dateFormat(val.exp_date, "dd-mmm-yy") : "-",
              Status: statusBadge,
              Edit: editButton,
              id: val.id,
            });
            tableDatafull.push(val);
          });
        }
        this.setState({
          tableData: tableData,
          wk_Mn_Yr_Full_Data: tableDatafull,
          props_loading: false,
          spinner: false,
        });
      })
      .catch((error) => {
        console.error("getTableData error:", error);
        this.setState({ props_loading: false, spinner: false });
      });
  };
  submitAdvanceFilter = (selected_doctor_id) => {
    this.setState({ open_filter: false, selected_doctor_id }, () => {
      this.getTableData();
    });
  };
  

  render() {
    const { Search } = Input;
    const { t } = this.props;
    const { isModalOpen } = this.state; // Ensure that the modal open state is being tracked
    const isEditModalOpen = this.state.iseditModalOpen;
    const heading = [
      { id: "sno", label: t("tbl_head_s_no") },
      { id: "Medicine_ID", label: "Medicine ID" },
      { id: "Medicine_Name", label: "Medicine Name" },
      { id: "Unit", label: "Stock" },
      { id: "Price", label: "Per Stock Price" },
      { id: "Qty", label: "Per Tablet Price" },
      { id: "MFG_Date", label: "MFG Date" },
      { id: "EXP_Date", label: "EXP Date" },
      { id: "Status", label: "Status" },
      { id: "edit", label: "Edit" },
    ];

    var searchData = [];
    const searchStr = (this.state.search !== undefined && this.state.search !== null) ? this.state.search.toString().trim().toLowerCase() : "";
    this.state.tableData.forEach((data) => {
      const matchId = data.id !== null && data.id !== undefined && data.id.toString().toLowerCase().includes(searchStr);
      const matchMedId = data.Medicine_ID !== null && data.Medicine_ID !== undefined && data.Medicine_ID.toString().toLowerCase().includes(searchStr);
      const matchMedName = (data.Medicine_Name && data.Medicine_Name.toString().toLowerCase().includes(searchStr)) ||
                           (data.medicine_name && data.medicine_name.toString().toLowerCase().includes(searchStr));

      if (!searchStr || matchId || matchMedId || matchMedName) {
        searchData.push({
          Medicine_ID: data.Medicine_ID,
          Medicine_Name: data.Medicine_Name,
          Unit: data.Unit,
          Price: data.Price,
          Qty: data.Qty,
          MFG_Date: data.MFG_Date,
          EXP_Date: data.EXP_Date,
          Status: data.Status,
          Edit: data.Edit,
          id: data.id,
        });
      }
    });
    return (
      <div className="p-4 sm:p-5 max-w-[1600px] mx-auto space-y-4 sm:space-y-5 animate-fadeIn">
        {/* Top Navigation & Action Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-white p-3.5 sm:p-4 rounded-xl border border-gray-100 shadow-2xs">
          <div className="flex items-center gap-3">
            <NavLink
              to="/Home/dashboard"
              className="w-8 h-8 rounded-lg bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white flex items-center justify-center transition-all duration-300 shadow-2xs active:scale-95 group"
              title="Back to Dashboard"
            >
              <svg className="w-4 h-4 stroke-[2.5] transform group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </NavLink>
            <div>
              <div className="flex items-center gap-2">
                <h1 className="text-base sm:text-lg font-bold text-gray-900 tracking-tight">
                  Medicine <span className="text-teal-600">Inventory</span>
                </h1>
                <span className="px-2 py-0.5 rounded-full bg-teal-50 text-teal-700 text-[10px] font-bold border border-teal-100">
                  {searchData.length} {searchData.length === 1 ? "item" : "items"}
                </span>
              </div>
              <p className="text-xs text-gray-500 font-medium mt-0.5">
                Manage pharmacy stock rates, batch manufacturing details, and expiration schedules
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2.5">
            {/* Search Input */}
            <div className="relative min-w-[240px]">
              <input
                type="text"
                placeholder="Search medicine name or ID..."
                value={this.state.search || ""}
                onChange={this.searchChange}
                className="w-full pl-9 pr-3 py-1.5 rounded-lg border border-gray-300 bg-gray-50/50 focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all"
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>

            {/* Add Medicine Button */}
            <button
              type="button"
              onClick={this.handleOpenModal}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-teal-600 hover:bg-teal-700 text-white text-xs font-bold rounded-lg transition-all shadow-sm shadow-teal-600/20 active:scale-95 cursor-pointer"
            >
              <HiOutlinePlusCircle size={16} />
              Add Medicine
            </button>
          </div>
        </div>

        {/* Table Container Card */}
        {(() => {
          const currentPage = this.state.page || 1;
          const pageSize = this.state.rowsPerPage || 25;
          const totalPages = Math.ceil(searchData.length / pageSize) || 1;
          const paginatedData = searchData.slice((currentPage - 1) * pageSize, currentPage * pageSize);
          const getPageNumbers = (current, total) => {
            if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
            let start = Math.max(1, current - 2);
            let end = Math.min(total, start + 4);
            if (end - start < 4) start = Math.max(1, end - 4);
            const pages = [];
            for (let i = start; i <= end; i++) pages.push(i);
            return pages;
          };

          const pageNumbers = getPageNumbers(currentPage, totalPages);
          const startPage = pageNumbers[0];
          const endPage = pageNumbers[pageNumbers.length - 1];

          return (
            <div className="bg-white rounded-xl border border-gray-100 shadow-2xs overflow-hidden flex flex-col">
              <div className="overflow-x-auto w-full">
                <table className="w-full text-left border-collapse min-w-[950px]">
                  <thead>
                    <tr className="bg-slate-50/90 border-b border-gray-200 text-xs font-bold text-slate-700 uppercase tracking-wider select-none">
                      <th className="py-2.5 px-3 text-center w-12 shrink-0">S.No</th>
                      <th className="py-2.5 px-3 text-center w-28 whitespace-nowrap">Medicine ID</th>
                      <th className="py-2.5 px-4 text-left min-w-[220px] whitespace-nowrap">Medicine Name</th>
                      <th className="py-2.5 px-3 text-center w-24 whitespace-nowrap">Stock</th>
                      <th className="py-2.5 px-3 text-right w-36 whitespace-nowrap">Per Stock Price</th>
                      <th className="py-2.5 px-3 text-right w-36 whitespace-nowrap">Per Tablet Price</th>
                      <th className="py-2.5 px-3 text-center w-32 whitespace-nowrap">MFG Date</th>
                      <th className="py-2.5 px-3 text-center w-32 whitespace-nowrap">EXP Date</th>
                      <th className="py-2.5 px-3 text-center w-28 whitespace-nowrap">Status</th>
                      <th className="py-2.5 px-3 text-center w-20 whitespace-nowrap">Edit</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 text-xs sm:text-sm">
                    {this.state.props_loading ? (
                      <tr>
                        <td colSpan={10} className="py-12 text-center text-gray-400 font-medium">
                          <div className="flex flex-col items-center justify-center gap-2">
                            <div className="w-6 h-6 border-2 border-teal-600 border-t-transparent rounded-full animate-spin" />
                            <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">Loading inventory data...</p>
                          </div>
                        </td>
                      </tr>
                    ) : paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="py-8 text-center text-slate-400 font-medium">
                          No medicines found.
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((data, index) => {
                        return (
                          <tr
                            key={data.id || index}
                            className="hover:bg-teal-50/30 transition-colors group"
                          >
                            {/* S.No */}
                            <td className="py-2.5 px-3 text-center text-xs font-bold text-slate-400">
                              {(currentPage - 1) * pageSize + index + 1}
                            </td>

                            {/* Medicine ID */}
                            <td className="py-2.5 px-3 text-center font-mono font-bold text-teal-700 text-xs sm:text-sm whitespace-nowrap">
                              {data.Medicine_ID}
                            </td>

                            {/* Medicine Name */}
                            <td className="py-2.5 px-4 text-left font-bold text-slate-800 text-xs sm:text-sm">
                              {data.Medicine_Name}
                            </td>

                            {/* Stock */}
                            <td className="py-2.5 px-3 text-center font-bold text-slate-700 text-xs sm:text-sm whitespace-nowrap">
                              {data.Unit}
                            </td>

                            {/* Per Stock Price */}
                            <td className="py-2.5 px-3 text-right font-medium text-slate-700 text-xs sm:text-sm whitespace-nowrap">
                              {data.Price}
                            </td>

                            {/* Per Tablet Price */}
                            <td className="py-2.5 px-3 text-right font-medium text-slate-700 text-xs sm:text-sm whitespace-nowrap">
                              {data.Qty}
                            </td>

                            {/* MFG Date */}
                            <td className="py-2.5 px-3 text-center text-slate-600 text-xs sm:text-sm whitespace-nowrap">
                              {data.MFG_Date}
                            </td>

                            {/* EXP Date */}
                            <td className="py-2.5 px-3 text-center text-slate-600 text-xs sm:text-sm whitespace-nowrap">
                              {data.EXP_Date}
                            </td>

                            {/* Status */}
                            <td className="py-2.5 px-3 text-center text-xs sm:text-sm whitespace-nowrap">
                              {data.Status}
                            </td>

                            {/* Edit */}
                            <td className="py-2.5 px-3 text-center whitespace-nowrap">
                              {data.Edit}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              {/* Modern Orderly Pagination Footer */}
              {searchData.length > 0 && (
                <div className="flex flex-col md:flex-row items-center justify-between gap-3 px-4 sm:px-6 py-3.5 border-t border-gray-100 bg-slate-50/50 text-xs sm:text-sm">
                  <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 text-slate-600 font-medium">
                    <span className="whitespace-nowrap">
                      Showing <span className="font-bold text-slate-900">{(currentPage - 1) * pageSize + 1}</span> to{" "}
                      <span className="font-bold text-slate-900">
                        {Math.min(currentPage * pageSize, searchData.length)}
                      </span>{" "}
                      of <span className="font-bold text-slate-900">{searchData.length}</span> medicines
                    </span>
                    <div className="flex items-center gap-1.5 ml-2 whitespace-nowrap">
                      <span className="font-semibold text-slate-700">Rows:</span>
                      <select
                        value={pageSize}
                        onChange={(e) => this.setState({ rowsPerPage: Number(e.target.value), page: 1 })}
                        className="px-2 py-1 bg-white border border-gray-200 rounded-lg text-xs font-bold text-slate-700 outline-none cursor-pointer focus:border-teal-500"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>

                  {/* Page navigation buttons */}
                  <div className="flex items-center gap-1 sm:gap-1.5 flex-wrap justify-center">
                    <button
                      type="button"
                      disabled={currentPage === 1}
                      onClick={() => this.setState({ page: currentPage - 1 })}
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                        currentPage === 1
                          ? "text-slate-300 bg-transparent cursor-not-allowed border border-transparent"
                          : "text-slate-700 bg-white hover:bg-teal-50 hover:text-teal-700 border border-gray-200 cursor-pointer shadow-2xs"
                      }`}
                    >
                      Previous
                    </button>

                    {startPage > 1 && (
                      <>
                        <button
                          type="button"
                          onClick={() => this.setState({ page: 1 })}
                          className="w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                        >
                          1
                        </button>
                        {startPage > 2 && <span className="text-slate-400 text-xs px-0.5 select-none">...</span>}
                      </>
                    )}

                    {pageNumbers.map((pageNum) => (
                      <button
                        key={pageNum}
                        type="button"
                        onClick={() => this.setState({ page: pageNum })}
                        className={`w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer ${
                          currentPage === pageNum
                            ? "bg-teal-600 text-white shadow-xs shadow-teal-600/30"
                            : "bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                        }`}
                      >
                        {pageNum}
                      </button>
                    ))}

                    {endPage < totalPages && (
                      <>
                        {endPage < totalPages - 1 && <span className="text-slate-400 text-xs px-0.5 select-none">...</span>}
                        <button
                          type="button"
                          onClick={() => this.setState({ page: totalPages })}
                          className="w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                        >
                          {totalPages}
                        </button>
                      </>
                    )}

                    <button
                      type="button"
                      disabled={currentPage === totalPages}
                      onClick={() => this.setState({ page: currentPage + 1 })}
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                        currentPage === totalPages
                          ? "text-slate-300 bg-transparent cursor-not-allowed border border-transparent"
                          : "text-slate-700 bg-white hover:bg-teal-50 hover:text-teal-700 border border-gray-200 cursor-pointer shadow-2xs"
                      }`}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })()}

        {/* Add Medicine Modal */}
        {isModalOpen && (
          <AddmedicineModal
            handleopenSuccess={this.handleopenSuccess}
            onClose={this.handleCloseModal}
          />
        )}

        {/* Edit Medicine Modal */}
        {isEditModalOpen && (
          <Editmedicine
            data={this.state.medicineData}
            medicineID={this.state.medicineID}
            editModalOpen={isEditModalOpen}
            handleopenSuccess={this.handleopenSuccess}
            onClose={this.editCloseModal}
          />
        )}

        {/* Toast Notification */}
        <ShowNotification
          visible={this.state.visible}
          successmsg={this.state.successmsg}
          issuccess={this.state.issuccess}
          handleCloseSuccess={this.handleCloseSuccess}
        />
      </div>
    );
  }


}
export default withTranslation()(TotalMaster);
